class CollectionLoadingButton extends HTMLElement
{
	constructor() {
		super();
	}

	fetchData(cb = null) {
		const productGrid = document.getElementById(this.dataset.productGrid);
		productGrid.parentElement.classList.add('loading');
		fetch(`${this.dataset.url}`, {method: 'GET'})
		.then((response) => {
			return response.text();
		})
		.then(responseText => {
			productGrid.parentElement.classList.remove('loading');
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			let responseProductItems = responseHTML.querySelectorAll(`#${this.dataset.productGrid} > *`);
			
			if(responseProductItems.length > 0) {
				if(this.dataset.loadingType == 'next') {
					responseProductItems.forEach(element => {
						productGrid.appendChild(element);
					});
				} else {
					Array.from(responseProductItems).reverse().forEach(element => productGrid.prepend(element));
				}
				if(window.appearAnimate) {
					const appear_animate_list = this.closest('appear-animate-list');
					if(appear_animate_list) {
						appear_animate_list.reset();
					}
				}
			}

			const newButton = responseHTML.querySelector(`.collection__loading-button[data-loading-type="${this.dataset.loadingType}"]`);
			if(newButton) {
				if(this.dataset.loadingType == 'next') {
					this.parentElement.appendChild(newButton);
				} else {
					this.parentElement.prepend(newButton);
				}
			}

			let urlParams = new URLSearchParams(this.dataset.url.split('?')[1]);
			urlParams.delete('section_id');
			const params = urlParams.toString();
			// 11:11 (Oct 29): the address bar no longer changes to ?page=N while products load. Owner asked:
			// with it, a refresh, Back or a shared link opened only the last page (e.g. /collections/gift-sets?page=3).
			// Rollback: restore the line below.
			// history.pushState({ params }, "", `${this.dataset.url.split('?')[0]}?${params}`);

			this.remove();

			if(cb) {
				cb();
			}

			console.log("load more products");
			window.Samita?.ProductLabels?.init?.();
		})
		.catch(e => {
			productGrid.parentElement.classList.remove('loading');
			// 11:11 (Oct 26): if the page failed to load (slow mobile network), try again shortly
			if (this.isConnected && typeof this.arm === 'function') {
				this.retries = (this.retries || 0) + 1;
				if (this.retries <= 5) setTimeout(() => { if (this.isConnected) this.arm(); }, 1500 * this.retries);
			}
		});
	}
}

class CollectionInfiniteButton extends CollectionLoadingButton
{
  connectedCallback() {
		this.arm();
	}

	// 11:11 (Oct 26): load the next page before the shopper reaches the end, and also when a fast scroll
	// has already gone past it (the top margin covers everything above the screen)
	arm() {
		if (this.observer) this.observer.disconnect();
		this.observer = new IntersectionObserver((entries, observer) => {
			if(entries[0].isIntersecting) {
				observer.disconnect();
				this.fetchData();
				// 11:11 (Oct 26): no white overlay over the grid for automatic loads
				document.getElementById(this.dataset.productGrid)?.parentElement?.classList.remove('loading');
			}
		}, { rootMargin: this.dataset.loadingType === 'prev' ? '0px' : '100000px 0px 1200px 0px' });
		this.observer.observe(this);
	}

	disconnectedCallback() {
		if (this.observer) this.observer.disconnect();
	}
}

customElements.define('collection-infinite-button', CollectionInfiniteButton);

class CollectionLoadMoreButton extends CollectionLoadingButton
{
	connectedCallback() {
		this.addEventListener('click', this.onClick);
	}

	onClick() {
		this.removeEventListener('click', this.onClick);
		this.fetchData();
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);
	}
}

customElements.define('collection-load-more-button', CollectionLoadMoreButton);